import React from 'react';
import { FormattedMessage } from 'react-intl';
import { reportError } from 'src/easyclaim.app.libs/reportError';

// @ts-ignore
import styles from './styles/ShowExamplePhoto.module.css';

interface ShowPhotoExampleProps {
	id: string;
	onClick: () => void | Promise<void>;
	children?: (description: React.ReactNode[]) => React.ReactElement;
}

export default function ShowExamplePhoto({ id, onClick, children }: ShowPhotoExampleProps) {
	return (
		<FormattedMessage id={id}>
			{(translatedText) => (
				<a
					href="#"
					className={`${styles.showExampleLink} ImageContainer-exemplaryPhoto`}
					onClick={(e) => {
						e.preventDefault();
						Promise.resolve(onClick()).catch((error) => {
							reportError(error, { context: 'ShowExamplePhoto.onClick', messageId: id });
						});
					}}
				>
					{children ? children([translatedText]) : translatedText}
				</a>
			)}
		</FormattedMessage>
	);
}
